import type { FunctionComponent, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { PositionAndSizeFromProps } from '../../utils/styledcomponents';
import type { PositionAndSizeProps } from '../../utils/styledcomponents';

const Block = styled.div`
	background-color: ${(props) => props.theme.colors.white};
	border-radius: 12vmin;
	box-shadow: ${(props) => props.theme.shadow.textBlock};
	color: ${(props) => props.theme.colors.darkText};
	font: ${(props) => props.theme.font.default};
	overflow: hidden;
	padding-left: 8vmin;
	padding-right: 8vmin;
	text-align: center;
`;

interface Props {
	className?: string;
}

const TextBlock: FunctionComponent<Props> = (
	props: PropsWithChildren<Props>
) => {
	const { children, className } = props;

	return <Block className={className}>{children}</Block>;
};

export default styled(TextBlock)<PositionAndSizeProps>(
	PositionAndSizeFromProps
);
